import classNames from 'classnames'
import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'

import * as Styles from './plan.module.scss'
import { Contact } from '@/components/general/contact'
import { Layout } from '@/components/general/layout'
import { PageTitle } from '@/components/general/page-title'
import { Seo } from '@/components/general/seo'
import { PlanContent } from '@/components/plan/plan-content'

const PlanPage = ({ location }) => (
  <Layout location={location}>
    <Seo
      title="料金プラン"
      description="クラウド決算開示管理サービス【Uniforce】の料金プランについて。Uniforce全機能の利用と公認会計士による導入サポートがついたベーシックプラン。ベーシックプランのサービス内容に追加して、決算開示業務の進行管理と決算開示業務に関するアドバイスを公認会計士が行うアドバンスドプラン。"
    />
    <PageTitle
      decorationLogo
      en="Plan"
      title="料金プラン"
      className={Styles.allPlan__pageTitle}
      decorationLogo
    />
    <div className={Styles.wrap}>
      <PlanContent />
    </div>

    <section>
      <div className={Styles.planWrap}>
        <h2>全てのプランでできること</h2>
        <ul className={Styles.allPlan}>
          <li>
            <div className={Styles.allPlanImage}>
              <StaticImage
                src="../images/plan_image_section-1-1.png"
                height={131}
              />
            </div>
            <h3>タスク・スケジュール自動作成機能</h3>
            <ul>
              <li>タスク自動作成機能</li>
              <li>スケジュール自動作成機能</li>
            </ul>
          </li>
          <li>
            <div className={Styles.allPlanImage}>
              <StaticImage
                src="../images/plan_image_section-1-2.png"
                height={142}
              />
            </div>
            <h3>チーム・個別タスク管理機能</h3>
            <ul>
              <li>オリジナルタスク作成機能</li>
              <li>タスク変更履歴の保存機能</li>
              <li>高度なフィルタリング機能</li>
            </ul>
          </li>
          <li>
            <div className={Styles.allPlanImage}>
              <StaticImage
                src="../images/plan_image_section-1-3.png"
                height={118}
              />
            </div>
            <h3>進行管理機能</h3>
            <ul>
              <li>リアルタイムレポート機能</li>
              <li>メンバーごとの進捗管理機能</li>
              <li>進捗レポート機能</li>
            </ul>
          </li>
        </ul>
      </div>
    </section>
    <section>
      <div className={classNames(Styles.planWrap, Styles.planWrap__blue)}>
        <h2>アドバンスドプランでできること</h2>
        <ul className={Styles.allPlan}>
          <li>
            <div className={Styles.allPlanImage}>
              <StaticImage
                src="../images/plan_image_section-2-1.png"
                height={140}
              />
            </div>
            <h3>
              ベーシックプランの
              <br />
              全機能
            </h3>
            <p>
              ベーシックプランで
              <br />
              利用可能な全ての機能が
              <br />
              ご利用いただけます。
            </p>
          </li>
          <li>
            <div className={Styles.allPlanImage}>
              <StaticImage
                src="../images/plan_image_section-2-2.png"
                height={134}
              />
            </div>

            <h3>
              公認会計士による
              <br />
              開示書類作成のサポート
            </h3>

            <p>
              決済開示書類の作成において
              <br />
              不明点があれば、公認会計士が
              <br />
              サポートさせていただきます。
            </p>
          </li>
          <li>
            <div className={Styles.allPlanImage}>
              <StaticImage
                src="../images/plan_image_section-2-3.png"
                height={143}
              />
            </div>
            <h3>
              公認会計士による
              <br />
              同業界の開示情報・株価分析
            </h3>
            <p>
              開示情報や株価分析
              <br />
              開示内容の改善を公認会計士が
              <br />
              サポートさせていただきます。
            </p>
          </li>
        </ul>
      </div>
    </section>
    <Contact />
  </Layout>
)

export default PlanPage
